var _style, _rect, _ellipse, _circle, _circle2, _path, _rect2, _rect3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 432 252",
    style: {
      enableBackground: "new 0 0 432 252"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000047741190310191628830000010905947618995935361_);}\n\t.st3{fill:url(#SVGID_00000119115099205906007910000013799787343955013303_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000183214751629090757070000010047313264053426600_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000033364908388183237830000008911028509065767330_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_00000008115396899899033630000006635202509688948128_);}\n\t.st7{fill:url(#SVGID_00000158717461309567165440000006002371552920520887_);}\n\t.st8{fill:#C6D9FF;}\n\t.st9{fill:#CBDDFF;}\n\t.st10{fill:none;stroke:#C6D9FF;stroke-width:2.6;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 432,
    height: 252
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 218,
    y1: -1512.0155,
    x2: 218,
    y2: -1705.0155,
    gradientTransform: "matrix(1 0 0 -1 0 -1482.0154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DFEAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DFEAFF",
      stopOpacity: 0
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 218,
    cy: 126.5,
    rx: 97,
    ry: 96.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028287996625795646160000009444886857649915274_",
    gradientUnits: "userSpaceOnUse",
    x1: 300,
    y1: 162.9843,
    x2: 300,
    y2: 82.9843,
    gradientTransform: "matrix(1 0 0 -1 0 251.9844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82ADFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E57E1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028287996625795646160000009444886857649915274_)"
    },
    d: "M300,89c-22.1,0-40,17.9-40,40 s17.9,40,40,40s40-17.9,40-40S322.1,89,300,89z M317.4,126.6c0,10.4-7.2,20.1-16.9,22.5c-9.7-2.4-16.9-12.1-16.9-22.5v-11.2 l16.9-7.5l16.9,7.5V126.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183930547638625264750000002706101241668522153_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.55,
    y1: 131.7843,
    x2: 300.55,
    y2: 114.0843,
    gradientTransform: "matrix(1 0 0 -1 0 251.9844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82ADFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E57E1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183930547638625264750000002706101241668522153_)"
    },
    points: "291.9,127.8 289.3,130.4  296.8,137.9 311.8,122.9 309.2,120.2 296.8,132.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052804989106173692190000014433794015906507679_",
    gradientUnits: "userSpaceOnUse",
    x1: 98,
    y1: 174.7843,
    x2: 98,
    y2: 165.7843,
    gradientTransform: "matrix(1 0 0 -1 0 251.9844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82ADFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E57E1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000052804989106173692190000014433794015906507679_)"
    },
    d: " M106.5,81.6c0-2.9-5.7-4.4-8.5-4.4s-8.5,1.6-8.5,4.4c1.8,2.8,5,4.6,8.5,4.6S104.7,84.4,106.5,81.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022548320262004580710000002788686915005748906_",
    gradientUnits: "userSpaceOnUse",
    x1: 98,
    y1: 185.8842,
    x2: 98,
    y2: 177.4843,
    gradientTransform: "matrix(1 0 0 -1 0 251.9844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82ADFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E57E1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000022548320262004580710000002788686915005748906_)"
    },
    cx: 98,
    cy: 70.3,
    r: 4.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085970921940068917820000012337557315725157784_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.1,
    y1: 200.9843,
    x2: 115.1,
    y2: 100.9843,
    gradientTransform: "matrix(1 0 0 -1 0 251.9844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82ADFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E57E1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000085970921940068917820000012337557315725157784_)"
    },
    d: " M158.7,52.5c-0.9-0.9-2.2-1.5-3.5-1.5H75c-1.3,0-2.6,0.5-3.5,1.5c-1,0.9-1.5,2.2-1.5,3.5v90c0,1.3,0.5,2.6,1.5,3.5 c0.9,1,2.2,1.5,3.5,1.5h80.2c1.3,0,2.6-0.5,3.5-1.5c0.9-0.9,1.5-2.2,1.5-3.5V56C160.2,54.7,159.7,53.4,158.7,52.5z M83.8,76 c0-7.9,6.4-14.2,14.2-14.2s14.2,6.3,14.2,14.2S105.8,90.2,98,90.2S83.8,83.9,83.8,76z M140.2,131H90.1v-10h50.1V131z M140.2,111 H90.1v-10h50.1V111z M140.2,86h-20.1V76h20.1V86z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    className: "st0",
    cx: 181.5,
    cy: 165.3,
    r: 46.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183938518138201909310000010290384494676506782_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.35,
    y1: 186.2001,
    x2: 181.35,
    y2: 142.3001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#82ADFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0E57E1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183938518138201909310000010290384494676506782_)"
    },
    d: "M193.8,156.9h-2.1v-4.2 c0-5.8-4.7-10.4-10.4-10.4c-5.8,0-10.4,4.7-10.4,10.4v4.2h-2.1c-2.3,0-4.2,1.9-4.2,4.2V182c0,2.3,1.9,4.2,4.2,4.2h25.1 c2.3,0,4.2-1.9,4.2-4.2v-20.9C197.9,158.8,196.1,156.9,193.8,156.9z M181.2,175.7c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2 s4.2,1.9,4.2,4.2S183.5,175.7,181.2,175.7z M187.6,156.9H175v-4.2c0-3.5,2.8-6.3,6.3-6.3s6.3,2.8,6.3,6.3V156.9z"
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 36.2,
    cy: 80.2,
    r: 5.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M367.6,155l4,6.8h-7.9L367.6,155z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 335.6,
    y: 56.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 56.6471 257.7596)",
    className: "st9",
    width: 7.8,
    height: 7.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 169,
    className: "st9",
    width: 7.8,
    height: 7.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 383.5,
    y1: 98.8,
    x2: 399.5,
    y2: 91.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.38e2277f24444854ab175682bd5f25f7.svg";
export { ForwardRef as ReactComponent };